import type { ComponentProps } from 'react';

const ChevronUp = (props: ComponentProps<'svg'>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3212_68257)">
      <path
        d="M30.5833 21.9209C31.3666 21.1375 32.6333 21.1375 33.4083 21.9209L49.4166 37.9209C50.2 38.7042 50.2 39.9709 49.4166 40.7459C48.6333 41.5209 47.3666 41.5292 46.5916 40.7459L32.0083 26.1625L17.4166 40.7542C16.6333 41.5375 15.3666 41.5375 14.5916 40.7542C13.8166 39.9709 13.8083 38.7042 14.5916 37.9292L30.5833 21.9209Z"
        fill="#8C98AB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.0547 22.3923L15.0633 38.4004L15.0605 38.4032C14.5455 38.9127 14.543 39.7572 15.0656 40.2854C15.5783 40.8036 16.4209 40.8072 16.9452 40.2828L32.0083 25.2198L47.0631 40.2745L47.0656 40.277C47.5751 40.7921 48.4196 40.7946 48.9478 40.272C49.466 39.7593 49.4696 38.9168 48.9453 38.3924C48.9453 38.3924 48.9454 38.3925 48.9453 38.3924L32.937 22.3924L32.9344 22.3898C32.4218 21.8717 31.5791 21.8682 31.0547 22.3923ZM33.8809 21.4507C32.8435 20.4036 31.1537 20.4077 30.1119 21.4495L14.1228 37.4553C14.1223 37.4558 14.1232 37.4549 14.1228 37.4553C13.0725 38.4959 13.0908 40.1851 14.1177 41.2231C15.155 42.2716 16.8458 42.2679 17.8881 41.2257L32.0083 27.1054L46.1177 41.2148C46.1172 41.2143 46.1182 41.2153 46.1177 41.2148C47.1583 42.2649 48.8476 42.2467 49.8855 41.2198C50.934 40.1825 50.9303 38.4918 49.8881 37.4495L33.8809 21.4507C33.8813 21.4511 33.8804 21.4502 33.8809 21.4507Z"
        fill="#8C98AB"
      />
    </g>
    <defs>
      <clipPath id="clip0_3212_68257">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ChevronUp;
